import { getLanguageCode } from '../utilities';

export default class ShoppinglistClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/api-shoppinglist-' + languageCode;
        this._dataSrc = 'shoppingLists';
    }

    get uri()
    {
        return this._uri;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }

    /**
	 * GET
	 */

    /**
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    fetchAllItems(shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/items/all');
    }

    /**
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    fetchShoppinglist(shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId);
    }

    /**
	 * @returns {Promise<Response>}
	 */
    fetchAllShoppinglists()
    {
        return fetch(this._uri);
    }

    /**
	 * @param shoppinglistId
	 * @param offset
	 * @param limit
	 * @returns {Promise<Response>}
	 */
    fetchItems(shoppinglistId, offset, limit)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/items', {
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                'skip': offset,
                'take': limit
            }
        });
    }

    /**
	 * POST
	 */

    /**
	 * @param data
	 * @returns {Promise<Response>}
	 */
    createShoppinglist(data)
    {
        return fetch(this._uri, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
    }

    /**
	 * PUT
	 */

    /**
	 * @param data
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    updateItems(data, shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/items', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    /**
	 * @param data
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    addItemsToCart(data, shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/items/add-to-cart', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    /**
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    addToCart(shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/add-to-cart', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    /**
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    replaceCart(shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/replace-cart', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    /**
	 * @param data
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    update(data, shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

    /**
	 * DELETE
	 */

    /**
	 * @param data
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    deleteItems(data, shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId + '/items', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
    }

    /**
	 * @param shoppinglistId
	 * @returns {Promise<Response>}
	 */
    deleteShoppinglist(shoppinglistId)
    {
        return fetch(this._uri + '/' + shoppinglistId, {
            method: 'DELETE',
        });
    }
}
